import axios from 'axios'
import authHeader from './auth-header'
const API_URL = 'https://arrandi.fr/api/admin/'

class AdminService {

    getAdminBoard () {
        return axios
        .post(API_URL + 'getAdminBoard', { token: JSON.parse(localStorage.getItem('user')).accessToken })
    }

    activateUser (userEmail) {
        const payload = { user: {email: userEmail}, token: JSON.parse(localStorage.getItem('user')).accessToken }
        // console.log("calling API activateUser : ", payload)
        return axios
        .post(API_URL + 'activateUser', payload)
    }

    deactivateUser (userEmail) {
        const payload = { user: {email: userEmail}, token: JSON.parse(localStorage.getItem('user')).accessToken }
        // console.log("calling API deactivateUser : ", payload)
        return axios
        .post(API_URL + 'deactivateUser', payload)
    }

    updateSubscription (userEmail, subscription) {
        const payload = { user: {email: userEmail, abonnement: subscription}, token: JSON.parse(localStorage.getItem('user')).accessToken }
        // console.log("calling API updateSubscription : ", payload)
        return axios
        .post(API_URL + 'updateSubscription', payload)
    }

    isAdmin() {
        return axios
        .post(API_URL + 'isAdmin', { token: JSON.parse(localStorage.getItem('user')).accessToken })
    }

}
export default new AdminService()